// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".line-item[data-v-db1a696a]{border-top:2px solid #0f0f92;padding:var(--header-gutter-top) 0}.line-item[data-v-db1a696a] .number{--number-border:0;--number-border-radius:0;--number-height:1em;--number-background:transparent;--number-gutter:0 0.75em;align-items:center;display:flex;flex:nowrap}.line-item[data-v-db1a696a] .number__label{margin-right:.75em;text-transform:uppercase}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
